import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { trackSearch } from '../utils/analytics';
import ThemeToggle from './ThemeToggle';
import './Header.css';

function Header() {
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(false);
  
  useEffect(() => {
    const checkTheme = () => {
      setIsDark(document.body.classList.contains('dark-mode'));
    };
    
    checkTheme();
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    
    return () => observer.disconnect();
  }, []);
  
  const handleSearch = (query) => {
    if (query.trim()) {
      trackSearch(query.trim());
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
    }
  };
  return (
    <>
      {/* E Forum Banner - Above Header */}
      <div className="eforum-banner">
        <div className="eforum-banner-container">
          <div className="eforum-text-section">
            <h1 style={{fontSize: '2.8rem', fontWeight: '700', margin: '0', letterSpacing: '1px', fontFamily: 'Times New Roman, Times, serif', display: 'flex', alignItems: 'center', gap: '0.4rem'}}>
              <span style={{color: isDark ? '#ffffff' : '#000000', fontSize: '3.2rem', fontWeight: '900', fontFamily: 'Times New Roman, Times, serif'}}>E</span>
              <span style={{color: isDark ? '#ffffff' : '#000000', fontSize: '2.8rem', fontWeight: '600', textTransform: 'uppercase', fontFamily: 'Times New Roman, Times, serif'}}>MEDIA</span>
              <span style={{color: isDark ? '#ffffff' : '#000000', fontSize: '2.8rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '2px', fontFamily: 'Times New Roman, Times, serif'}}>FORUM</span>
            </h1>
          </div>
        </div>
      </div>
      
      {/* Navigation Header */}
      <header className="header">
        <nav className="main-nav">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/film" className="nav-link">Film</Link>
          <Link to="/tv" className="nav-link">TV</Link>
          <Link to="/awards" className="nav-link">Awards</Link>
          <Link to="/festivals" className="nav-link">Festivals</Link>
          <Link to="/reviews" className="nav-link">Reviews</Link>
        </nav>
        <div className="header-actions">
          <div className="search-container">
            <input 
              type="text" 
              placeholder="Search E FORUM articles..."
              className="search-input"
              onKeyPress={(e) => e.key === 'Enter' && handleSearch(e.target.value)}
            />
            <button className="search-btn" onClick={() => handleSearch(document.querySelector('.search-input').value)}>
              <FaSearch />
            </button>
          </div>
          <ThemeToggle />
        </div>
      </header>
    </>
  );
}

export default Header;
